/*
 *  -----------------------------------------------------------------------
 *    <copyright file="manage-signatory-dialog.data.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

export const SignatoryInitialState = {
    firstName: '',
    lastName: '',
    jobTitle: '',
};
